<template>
    <div class="container-fluid pt-2">
        <div class="card">
            <div class="card-header">
                <div class="d-flex justify-content-between align-items-center">
                    <h5>Sales Comission</h5>
                    <button class="btn btn-sm btn-primary" @click="isform = !isform"><i
                            class="fa fa-solid fa-plus"></i> Create</button>
                </div>
            </div>
            <div class="card-body py-1" id="body-salesorder">
                <div class="row">
                    <div class="col-md-3 mb-1">
                        <select v-model="params.divisi_id" class="form-select">
                            <option value="" disabled>Select Divisi</option>
                            <option v-for="option in divisiOptions" :key="option.ID" :value="option.ID">
                                {{ (option as any).name }}
                            </option>
                        </select>
                    </div>

                    <div class="col-md-3 mb-1">
                        <select v-model="params.divisi_team_id" class="form-select">
                            <option value="">Select Team</option>
                            <option v-for="option in divisiTeamOptions" :key="option.ID" :value="option.ID">
                                {{ option?.name }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="card-body py-1">
                <DataTable
                    :headers="headers"
                    :items="salesComission"
                    :loading="loading"
                    :total="total"
                    :params="params"
                    :selectable="true"
                    :multiSelectable="false"
                    @update:params="updateParams"
                    @selection-change="handleSelectionChange"
                >
                    <template #item.comission_start_date="{ item }" style="white-space: nowrap;word-wrap: break-word;">
                        {{ formatDate(item.comission_start_date) }}
                    </template>
                    <template #item.comission_end_date="{ item }" style="white-space: nowrap;word-wrap: break-word;">
                        {{ formatDate(item.comission_end_date) }}
                    </template>
                    <template #item.divisi_team_name="{ item }" style="white-space: nowrap;word-wrap: break-word;">
                        {{ item.divisi_team_name }}
                    </template>
                    <template #item.actions="{ item }">
                        <button class="btn btn-sm btn-warning me-1" @click.stop="editComission(item)">
                            <i class="fa fa-solid fa-edit"></i>
                        </button>
                        <button class="btn btn-sm btn-danger" @click.stop="deleteComission(item.ID)">
                            <i class="fa fa-solid fa-trash"></i>
                        </button>
                    </template>
                </DataTable>
            </div>
            <br/>
            <div class="card-body py-1" v-if="selectedComissionId">
                <h6>Comission Details</h6>
                <div class="table-responsive">
                    <table class="table table-sm table-hover">
                        <thead class="table-light">
                            <tr>
                                <th class="text-center">No</th>
                                <th>Periode</th>
                                <th class="text-end">Target 1</th>
                                <th class="text-end">Amount 1</th>
                                <th class="text-end">Target 2</th>
                                <th class="text-end">Amount 2</th>
                                <th class="text-end">Target 3</th>
                                <th class="text-end">Amount 3</th>
                                <th class="text-end">Target 4</th>
                                <th class="text-end">Amount 4</th>
                                <th class="text-end">Target 5</th>
                                <th class="text-end">Amount 5</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="loadingDetails">
                                <td colspan="12" class="text-center">
                                    <div class="spinner-border text-primary" role="status">
                                        <span class="visually-hidden">Loading...</span>
                                    </div>
                                </td>
                            </tr>
                            <tr v-else-if="!comissionDetails.length">
                                <td colspan="12" class="text-center">
                                    No details available
                                </td>
                            </tr>
                            <tr v-else v-for="(detail, index) in comissionDetails" :key="detail.ID">
                                <td class="text-center">{{ index + 1 }}</td>
                                <td>{{ shortDate(detail.comission_start) }}</td>
                                <td class="text-end">{{ separator(detail.target_1 ?? 0) }}</td>
                                <td class="text-end">{{ formatCurrency(detail.amount_1 ?? 0) }}</td>
                                <td class="text-end">{{ separator(detail.target_2 ?? 0) }}</td>
                                <td class="text-end">{{ formatCurrency(detail.amount_2 ?? 0) }}</td>
                                <td class="text-end">{{ separator(detail.target_3 ?? 0) }}</td>
                                <td class="text-end">{{ formatCurrency(detail.amount_3 ?? 0) }}</td>
                                <td class="text-end">{{ separator(detail.target_4 ?? 0) }}</td>
                                <td class="text-end">{{ formatCurrency(detail.amount_4 ?? 0) }}</td>
                                <td class="text-end">{{ separator(detail.target_5 ?? 0) }}</td>
                                <td class="text-end">{{ formatCurrency(detail.amount_5 ?? 0) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <Form title="Create Sales Comission" v-if="isform" :data="data" @on-closed="isform = false; fetchSalesComission()" />
</template>

<script lang="ts" setup>
import { ref, reactive, watch, onMounted, defineAsyncComponent } from 'vue'
const Form = defineAsyncComponent(() => import("./Form.vue"))
import { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'
import DataTable from '@/components/table/DatatableDateRange.vue'
import { Modal } from 'bootstrap'
import * as sales from '@/api/services/SalesRequest'
import { useSessionStore } from '@/store/session';
const session = useSessionStore()
const isform = ref(false)
const data = ref<any | null>(null)
// {{ Define SalesOrder interface }}

const headers = [
    { text: 'Comission No', value: 'code' },
    { text: 'Start Date', value: 'comission_start_date' },
    { text: 'End Date', value: 'comission_end_date' },
    { text: 'Divisi Team', value: 'divisi_team_name' },
    { text: 'Note', value: 'notes' },
    { text: '#Act', value: 'actions' }
]

// {{ Apply types to refs and reactive objects }}
const salesComission = ref<any[]>([])
const loading = ref(false)
const total = ref(0)
const selectedComissionId = ref<number | null>(null)
const comissionDetails = ref<any[]>([])
const loadingDetails = ref(false)
const params = reactive<DataTableParams>({
    page: 1,
    size: 10,
    search: '',
    divisi_id: '',
    divisi_team_id: ''
})

const deleteComission = async (id: number) => {
    if (!confirm('Are you sure you want to delete this comission?')) return

    loading.value = true
    try {
        await sales.postRequest("/comission/delete", {ID: id}).then((resp) => {
            if (resp.status === 200) {
                toast.success('Comission deleted successfully');
                fetchSalesComission();
            } else {
                toast.error('Failed to delete Comission');
            }
        })

    } catch (error: any) {
        toast.error(error.message || 'Failed to delete Comission');
    } finally {
        loading.value = false
    }
}
const fetchSalesComission = async () => {
    data.value = null
    loading.value = true
    try {
        // Simulate API delay
        await sales.postRequest("/comission/list", params).then((response) => {
            salesComission.value = response.data;
            total.value = response.total
        });

    } catch (error) {
        toast.error('Failed to fetch sales closing')
    }
    loading.value = false
}

const editComission = (item: any) => {
    data.value = item
    isform.value = true
}

const updateParams = (newParams: Partial<DataTableParams>) => {
    Object.assign(params, newParams)
    fetchSalesComission()
}

const handleSelectionChange = async (selectedIds: any[]) => {
    const id = selectedIds && selectedIds.length ? selectedIds[0] : null
    selectedComissionId.value = id
    comissionDetails.value = []
    if (!id) return
    loadingDetails.value = true
    try {
        const response = await sales.postRequest("/comission/detail/list", { comission_id: id })
        comissionDetails.value = response.data || []
    } catch (error: any) {
        toast.error(error.message || 'Failed to fetch comission details')
    } finally {
        loadingDetails.value = false
    }
}

const modalRef = ref<HTMLElement | null>(null) // Type the ref
let bsModal: any | null = null // Type the bootstrap modal instance as any since Modal namespace can't be used directly
const divisiOptions = ref<any[]>([])
const divisiTeamOptions = ref<any[]>([])

watch(() => params.divisi_id, (newVal) => {
    params.divisi_id = newVal ? newVal : null;
    divisiTeamOptions.value = session.divisionOptions().find(d => d.ID === params.divisi_id)?.divisiTeams
});

onMounted(() => {
    divisiOptions.value = session.divisionOptions()
    params.divisi_id = divisiOptions.value.find((item) => item.name === session.getUser().divisi)?.ID
    divisiTeamOptions.value = session.divisionOptions().find(d => d.name === session.getUser().divisi)?.divisiTeams
    if (modalRef.value) { // Check if modalRef exists
        bsModal = new Modal(modalRef.value)
    }
})

function formatDate(dateString: string, part: string = "-", partTime: string = " "): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${dd}${part}${mm}${part}${yyyy}`;
}

function separator(value: number) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function formatCurrency(value: number) {
    return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0
    }).format(value);
}

function shortDate(dateStr: string) {
    if (!dateStr) return '-'
    const d = new Date(dateStr)
    const dd = String(d.getDate()).padStart(2, '0')
    const mm = String(d.getMonth() + 1).padStart(2, '0')
    const yyyy = d.getFullYear()
    const hh = String(d.getHours()).padStart(2, '0')
    const min = String(d.getMinutes()).padStart(2, '0')
    return `${dd}/${mm}/${yyyy} ${hh}:${min}`
}
</script>
